import { HTML, IFRAME, LINK } from '@/modules/app_content/common/content-types';

export default Object.freeze({
  [HTML]: 'html.edit',
  [IFRAME]: 'iframe.edit',
  [LINK]: 'link.edit'
});
